<template>
    <div class="link-select-service-controller">
        <link-select-service ref="services" v-for="(item) in items" :key="item"/>
    </div>
</template>

<script>
    import LinkSelectService from "./link-select-service";

    export default {
        name: "link-select-service-controller",
        components: {LinkSelectService},
        data() {
            return {
                items: [1],
            }
        },
        methods: {
            async select(option) {
                let service = !this.$refs.services ? null : this.$lv.$utils.findOne(this.$refs.services, item => !item.p_show)
                if (!service) {
                    this.items.push(this.items.length + 1)
                    await this.$lv.nextTick()
                    service = this.$lv.$utils.findOne(this.$refs.services, item => !item.popover || !item.p_show)
                }
                return service.select(option)
            },
        }
    }
</script>

<style lang="scss">
    @include themeify {

    }
</style>
